import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MemberProfileHeader = ({ member, isEditing, onEdit, onSave, onCancel, onDelete }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-6">
        {/* Profile Image */}
        <div className="flex-shrink-0 mb-4 lg:mb-0">
          <div className="relative">
            <div className="w-32 h-32 rounded-full overflow-hidden bg-muted border-4 border-white shadow-soft">
              <Image
                src={member?.profileImage || `https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face`}
                alt={`${member?.firstName} ${member?.lastName}`}
                className="w-full h-full object-cover"
              />
            </div>
            {isEditing && (
              <button className="absolute bottom-0 right-0 w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center shadow-soft hover-scale">
                <Icon name="Camera" size={16} />
              </button>
            )}
          </div>
        </div>

        {/* Basic Info */}
        <div className="flex-grow">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-4">
            <div>
              <h1 className="text-2xl font-semibold text-foreground mb-1">
                {member?.firstName} {member?.lastName}
              </h1>
              <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
                <div className="flex items-center space-x-1">
                  <Icon name="Hash" size={16} />
                  <span>ID: {member?.id}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Calendar" size={16} />
                  <span>Entrada: {new Date(member.registrationDate)?.toLocaleDateString()}</span>
                </div>
                {member?.lastModified && (
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={16} />
                    <span>Atualizado: {new Date(member.lastModified)?.toLocaleDateString()}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center space-x-2 mt-4 sm:mt-0">
              {!isEditing ? (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={onEdit}
                    iconName="Edit"
                    iconPosition="left"
                  >
                    Editar
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={onDelete}
                    iconName="Trash2"
                    iconPosition="left"
                  >
                    Excluir
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={onCancel}
                    iconName="X"
                    iconPosition="left"
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="default"
                    size="sm"
                    onClick={onSave}
                    iconName="Save"
                    iconPosition="left"
                  >
                    Salvar alterações
                  </Button>
                </>
              )}
            </div>
          </div>

          {/* Status Badges */}
          <div className="flex flex-wrap gap-2">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-success text-success-foreground">
              <Icon name="CheckCircle" size={12} className="mr-1" />
              Membro ativo
            </span>
            {member?.isVoterRegistered && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary text-primary-foreground">
                <Icon name="Vote" size={12} className="mr-1" />
                Eleitor cadastrado
              </span>
            )}
            {member?.membershipType && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
                <Icon name="Star" size={12} className="mr-1" />
                {member?.membershipType}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberProfileHeader;